import React, { cloneElement } from 'react';
import {
    List, Filter, TextInput, BooleanInput, Datagrid, TextField, EmailField, DeleteButton,
    TopToolbar, CreateButton, ExportButton, usePermissions, useRefresh, useListContext, sanitizeListRestProps
} from 'react-admin';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import EnableIcon from '@material-ui/icons/CheckCircle';

const ActionButtons = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        record,
    } = useListContext();

    return (
        <TopToolbar className="mb-3" {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} record={record} />
            <ExportButton />
        </TopToolbar>
    );
}

const InspectorFilter = (props) => (
    <Filter {...props}>
        <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Name</h6>} source="display_name" fullWidth variant="outlined" alwaysOn />
        <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Email</h6>} source="email" fullWidth variant="outlined" />
        <BooleanInput label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Active</h6>} source="active" options={{
            checkedIcon: <EnableIcon />,
            color: 'primary',
        }} />
    </Filter>
);

const ActiveTextField = ({ className, record, source }) => (
    <span className={(record[source]) ? 'text-success ' + className : 'text-danger ' + className}>{(record[source]) ? <CheckIcon /> : <ClearIcon />}</span>
);

const InspectorList = props => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    const inspectorDeleteButton = isAdmin ? (<DeleteButton redirect={toRedirect} />) : "";

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Inspectors</h3>
            <List {...props} title=" " filters={<InspectorFilter />} actions={<ActionButtons />} bulkActionButtons={false}>
                <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                    <ActiveTextField source="active" className="px-3" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Active </h6>} />
                    <TextField source="display_name" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name </h6>} />
                    <EmailField source="email" className="px-3 text-lowercase" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Email</h6>} />
                    <TextField source="phone" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Phone </h6>} />
                    {inspectorDeleteButton}
                </Datagrid>
            </List>
        </>
    )
};

export default InspectorList;
